import { ReactNode } from "react";
import { View } from "./View";
export interface IRecieptProps {
  topLeft: ReactNode;
  topRight: ReactNode;
  mainTitle: ReactNode;
  subTitle: ReactNode;
  extraPhrase: ReactNode;
  middletext: ReactNode;
  mainPage: ReactNode;
  // backgroundColor: string;

  // mainTopColor: string;
  // text_color: string;
}
export const Reciept = (props: IRecieptProps) => {
  return <View {...props} />;
};
